import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 15.25,
		y1: 8.75,
		x2: 3.25,
		y2: 8.75,
		stroke: "#868686",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 9.25,
		y1: 2.75,
		x2: 9.25,
		y2: 14.75,
		stroke: "#868686",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgIconPlus;
